import { API_HOST, authenticatedFetchData, authenticatedFetch } from '../lib'
import { uploadFile } from './file.service'
import type { HttpError } from '@tomra/client-side-http-client'

export const uploadCharityAttachment = (
  charityId: string,
  type: CharityFileAttachmentType['type'],
  file: Blob | File
) => {
  return authenticatedFetchData(`${API_HOST}/charities/admin/v2/charities/${charityId}/attachments/${type}/update`)
    .run()
    .then(({ url, headers }) => uploadFile(url, file, headers))
    .then(() => authenticatedFetchData(`${API_HOST}/charities/admin/v1/charities/${charityId}/attachments`).run())
}

export const loadNewCharityActions = () => {
  const newCharities = authenticatedFetchData(`${API_HOST}/charities/admin/v1/charities?status=NEW&limit=500&offset=0`)
  const newCampaigns = authenticatedFetchData(`${API_HOST}/charities/admin/v1/campaigns?status=NEW&limit=500&offset=0`)
  const newPendingCharities = authenticatedFetchData(
    `${API_HOST}/charities/admin/v1/pending-charities?limit=500&offset=0`
  )
  const newPendingCampaigns = authenticatedFetchData(
    `${API_HOST}/charities/admin/v1/pending-campaigns?limit=500&offset=0`
  )

  const runAll = () =>
    Promise.all([newCharities.run(), newCampaigns.run(), newPendingCharities.run(), newPendingCampaigns.run()]).then(
      ([charities, campaigns, pendingCharities, pendingCampaigns]) => {
        return {
          charities,
          campaigns,
          pendingCharities,
          pendingCampaigns
        }
      }
    )

  return {
    runAll,
    abortAll: () => {
      newCharities.abort()
      newCampaigns.abort()
      newPendingCharities.abort()
      newPendingCampaigns.abort()
    }
  }
}

export async function fetchPendingAttachments(charityId: string) {
  try {
    const fetchPendingAttachments = authenticatedFetch(`${API_HOST}/charities/admin/v1/pending-charities/${charityId}`)

    const { meta } = await fetchPendingAttachments.run().catch(error => {
      if (error?.status === 404) {
        return { attachments: [] }
      }

      throw error
    })

    const { attachments } = meta
    return attachments
  } catch (_error) {
    throw new Error('Failed to load charity attachments')
  }
}

export const updateCharityNote = (charityId: string, note: string) => {
  return authenticatedFetchData(`${API_HOST}/charities/admin/v1/charities/${charityId}/note`, {
    method: 'PUT',
    body: JSON.stringify({
      note
    })
  }).run()
}

export async function fetchPendingCampaign(charityId: string, campaignId: string) {
  try {
    return await authenticatedFetchData(
      `${API_HOST}/charities/admin/v1/charities/${charityId}/pending-campaigns/${campaignId}`
    ).run()
  } catch (error) {
    if ((error as HttpError).status === 404) {
      return null
    }

    throw error
  }
}
